import React, { useEffect, useRef } from 'react'

import { TURNSTILE_SITE_KEY, TURNSTILE_SCRIPT_SRC } from '../constants/turnstile'

let scriptPromise

const loadTurnstile = () => {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = TURNSTILE_SCRIPT_SRC
      script.async = true
      script.defer = true
      script.onload = resolve
      script.onerror = () => {
        scriptPromise = null
        reject()
      }
      document.head.appendChild(script)
    })
  }
  return scriptPromise
}

/** Renders a Turnstile widget and reports its token ('' when expired or failed). */
const Turnstile = ({ onToken }) => {
  const containerRef = useRef(null)
  const onTokenRef = useRef(onToken)
  onTokenRef.current = onToken

  useEffect(() => {
    let widgetId
    let cancelled = false

    loadTurnstile()
      .then(() => {
        if (cancelled || !containerRef.current) return
        widgetId = window.turnstile.render(containerRef.current, {
          sitekey: TURNSTILE_SITE_KEY,
          callback: token => onTokenRef.current(token),
          'expired-callback': () => onTokenRef.current(''),
          'error-callback': () => onTokenRef.current(''),
        })
      })
      .catch(() => onTokenRef.current(''))

    return () => {
      cancelled = true
      if (widgetId !== undefined && window.turnstile) {
        window.turnstile.remove(widgetId)
      }
    }
  }, [])

  return <div ref={containerRef} className="turnstile" />
}

export default Turnstile
